import component from './HotelDirectoryPreview.vue';

export const PREVIEW_AND_EDIT = 'previewAndEdit'
export default{
    id: PREVIEW_AND_EDIT,
    component,
}
